import React, {Component} from "react";

class TrackingInputForm extends Component {

  getCSSForDelete = (showDelete) => {
    if (showDelete === true) {
      return 'tracking__link-delete';
    }
    return 'tracking__link-delete-hide';
  };

  onFieldChange = (id, event) => {

    const regEx = /(^[0-9]+$|^$)/;

    if (!regEx.test(event.target.value)) {
      event.preventDefault();
    } else {
      const fieldName = event.target.name;
      const fieldValue = event.target.value;
      this.props.onChange(fieldName, fieldValue, id);
    }

  };

  deleteRow = (id) => {
    this.props.deleteRow(id);
  };

  validateAirlineCodeAndUpdateState = (id, event) => {
    this.props.validateAirlineCodeAndUpdateState(event.target.value, id);
  };

  validateTrackingNumberAndUpdateState = (id, event) => {
    this.props.validateTrackingNumberAndUpdateState(event.target.value, id);
  };

  restrictTrackingNumberInput = (e) => {
    if (e.key === "Enter") {
      return;
    }
    // regex to only allow numbers
    const regEx = /[0-9]+/g;
    if (!regEx.test(e.key)) {
      e.preventDefault();
    }

  };

  render() {
    return (
      <div className="tracking-input-wrapper" key={this.props.id}>
        <div>
          <label className="tracking-input-label">
            Airline Code
          </label>
          <label className="tracking-input-label">
            8-digit Air waybill
          </label>
        </div>
        <div className="input-container">
          <input type="text" name="airlineCode" value={this.props.airlineCode}
                 onChange={this.onFieldChange.bind(this, this.props.id)}
                 className={this.props.isAirlineCodeValid === true ? 'tracking-textbox tracking-textbox__small' : 'tracking-textbox tracking-textbox__small tracking-textbox-error'}
                 onBlur={this.validateAirlineCodeAndUpdateState.bind(this, this.props.id)}/>
          <img src="./assets/icons/error.svg" alt="error"
               className={this.props.isAirlineCodeValid === true ? 'error-input-hide' : 'errorImgSmallTextBox'}/>
            {/*pattern invokes number keypad on mobile devices and restricts input to numbers only*/}
            <input type="text" pattern="[0-9]*" inputMode="numeric" name="trackingNumber"
                   maxLength="8"
                   value={this.props.trackingNumber}
                   onChange={this.onFieldChange.bind(this, this.props.id)}
                   className={this.props.isTrackingNumberValid === true ? 'tracking-textbox tracking-textbox__big' : 'tracking-textbox tracking-textbox__big tracking-textbox-error'}
                   onBlur={this.validateTrackingNumberAndUpdateState.bind(this, this.props.id)}/>
          <img src="./assets/icons/error.svg" alt="error"
               className={this.props.isTrackingNumberValid === true ? 'error-input-hide' : 'errorImgLargeTextBox'}/>
        </div>
        <div>
          <div>
            <span className={this.getCSSForDelete(this.props.showDelete)} onClick={() => {
              this.deleteRow(this.props.id)
            }}> Delete </span>
          </div>
        </div>
      </div>);
  }

}

export default TrackingInputForm;


// WEBPACK FOOTER //
// ./src/components/TrackingInputForm/TrackingInputForm.js